export default "__VITE_ASSET__B0D3Oqr$__"